export default "__VITE_ASSET__BeJCOxzu__"